import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import getActiveApplications from 'core/services/getActiveApplications'
import showWeightHeight from 'FI/consumer/eligibility/showWeightHeight'
import { IS_ENROLL } from 'core/constants/environment'
import agentStore from 'utils/store/simple'
import getById from 'utils/DOM/getById'
import getComplianceParams from 'utils/pivot/compliance/getComplianceParams'
import { getCompliance } from 'core/services/getCompliance'

function handleResponse([agentInformation, compliance, enrollData]) {
  const questions = compliance.questions
  const questionsWrap = getById('questions-wrap')
  const template = Templater(getById('template-questions').innerText)
  const phone = agentInformation
    ? {
        phone: agentInformation.phone,
        phoneNumber: agentInformation.promo_number,
        completePhone: agentInformation.completePhone
      }
    : {}

  questionsWrap.innerHTML = questions
    .map(question => {
      return template({
        ...question,
        answerOptions: IS_ENROLL
          ? question.answerOptions.reverse()
          : question.answerOptions,
        ...phone
      })
    })
    .join('')

  return [questions, enrollData]
}

function loadQuestions(state, product: string) {
  const isFBM = product === 'FBM'
  const promises = [agentStore.getState(), getCompliance(getComplianceParams(state))]

  if (IS_ENROLL) {
    promises.push(getActiveApplications(state.hcStorage))
  }

  return Promise.all(promises)
    .then(handleResponse)
    .then(data => [
      ...data,
      isFBM
        ? showWeightHeight(
            state.hcStorage.members,
            document.forms.eligibility,
            state.hcStorage.childOnly,
            () => {
              return
            }
          )
        : undefined
    ])
}

export default loadQuestions
